import { Link } from '~/components/Link'
import { Radio } from '~/components/Radio'
import Status from '~/components/Status/Status'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { PreferredStoreListItemProps } from './PreferredStoreListItem.types'

export const PreferredStoreListItem = ({
  store,
  isSelected,
  onSelect,
  sku,
}: PreferredStoreListItemProps) => {
  const {
    displayName,
    isClickAndCollectAvailable,
    url,
    address: {
      streetNumber,
      streetName,
      city,
      state,
      postalCode,
      country,
      town,
    },
    isMarketplaceProduct,
  } = store

  return (
    <div className='flex items-center gap-x-3'>
      <Radio
        disabled={store?.isClickAndCollectAvailable === false}
        theme={{
          root: 'w-full',
          content: 'order-1 flex-1 max-w-none m-0 mr-3',
          radio: 'order-2 self-center',
        }}
        label={
          <div className='flex-1'>
            <Link href={url} title={displayName}>
              <Typography
                tag={TypographyTag.p}
                variant={TypographyVariant.BodyRegularBold}
                className='text-primary-heading'>
                {displayName}
              </Typography>
            </Link>

            <Typography
              tag={TypographyTag.p}
              variant={TypographyVariant.BodyRegular}
              className='mt-4 text-secondary-muted'>
              {streetNumber} {streetName}, {city || town}, {state} {postalCode},{' '}
              {country}
            </Typography>

            <Typography
              tag={TypographyTag.p}
              variant={TypographyVariant.BodyRegular}
              className='mt-1 text-secondary-muted'>
              {store?.distance}km away
            </Typography>

            {sku && (
              <div className='mt-3'>
                <Status
                  status={
                    isMarketplaceProduct
                      ? 'secondary'
                      : isClickAndCollectAvailable
                      ? 'success'
                      : 'error'
                  }
                  label={
                    <Typography
                      tag={TypographyTag.div}
                      variant={TypographyVariant.BodyRegular}
                      className='py-1 text-secondary-muted'>
                      {isMarketplaceProduct
                        ? 'Direct From Supplier'
                        : isClickAndCollectAvailable
                        ? '1hr Click & Collect'
                        : 'Click & Collect - Not Available'}
                    </Typography>
                  }
                />
              </div>
            )}
          </div>
        }
        size='lg'
        name={displayName?.toLowerCase().replaceAll(' ', '_')}
        checked={isSelected}
        defaultChecked={false}
        onChange={() => {
          return onSelect?.()
        }}
      />
    </div>
  )
}
